import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { translations } from "@/i18n/translations";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("wl_lang") || "am");

  useEffect(() => {
    localStorage.setItem("wl_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback((key) => translations[lang]?.[key] ?? translations.en[key] ?? key, [lang]);
  const tr = useCallback((obj) => (obj ? obj[lang] || obj.en || "" : ""), [lang]);

  const value = useMemo(() => ({ lang, setLang, t, tr }), [lang, t, tr]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
